import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { ZollApiResponse } from '../../zollApi/store/zollApi.types'

const fillablePdfsFetchUrl = `${zollBaseURL}/api/FillablePDFs/fetch`

export type fillablePdfsReq = Array<{ id: string; createDateTime: string }>

export interface IFillablePdfsFetchRequest {
  includePdfData?: boolean
  includeHidden?: boolean
  supplyOmittedDocuments?: boolean
  clientData: fillablePdfsReq
}

export interface IFillablePdfsFetchResponse extends ZollApiResponse {
  data: {
    clientData: Array<{
      id: string
      contentType: string
      contentDataType: string
      createDateTime: string
      docData?: string
      serviceId?: number
    }> | null
  }
}

export class FillablePdfsImportService extends ZollAPIService {
  async fetchFillablePdfs(data: IFillablePdfsFetchRequest): Promise<IFillablePdfsFetchResponse> {
    return this.postWithError(fillablePdfsFetchUrl, data)
  }
}
